import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/hooks';
import { getZendeskChatAccess } from './api';

export const useGetZendeskAccess = () => {
  const auth = useAuth();
  const accountId = auth?.data?.account?.id;
  const userId = auth?.data?.user?.id;
  const isMasqing = auth.data?.account?.is_masq === true;

  return useQuery({
    queryKey: ['zendeskChatAccess', accountId, userId],
    queryFn: async () => await getZendeskChatAccess(accountId, userId),
    enabled: accountId != null && userId != null && !isMasqing,
    staleTime: Infinity, // only fetch once
  });
};
